<template>
  <div class="w-100">
    <v-tabs
      v-model="tab"
      hide-slider>
      <v-tab
        v-for="(text, i) in tabs"
        :key="`barcode-setup-tab-${i}`">
        {{ text }}
      </v-tab>
    </v-tabs>
    <v-tabs-items
      v-model="tab"
      class="barcode-setup"
      touchless>
      <v-tab-item
        :value="0"
        class="pa-5">
        <div class="primary--text mb-5">
          ข้อมูลในบาร์โค้ด
        </div>
        <div class="d-flex align-center gap-3 mb-5">
          <div class="barcode-setup__label grey--text">
            ตำแหน่งบน
          </div>
          <snt-select
            :value="pos1"
            :items="positions"
            width="165px"
            item-text="text"
            item-value="value"
            hide-details
            @input="changePosition1($event)" />
        </div>
        <div class="d-flex align-center gap-3 mb-5">
          <div class="barcode-setup__label grey--text">
            ตำแหน่งกลาง
          </div>
          <snt-select
            :value="pos2"
            :items="midPositions"
            item-text="text"
            item-value="value"
            width="165px"
            hide-details
            @input="changePosition2($event)" />
        </div>
        <div class="d-flex align-center gap-3 mb-8">
          <div class="barcode-setup__label grey--text">
            ตำแหน่งล่าง
          </div>
          <snt-select
            :value="pos3"
            :items="lastPositions"
            width="165px"
            item-text="text"
            item-value="value"
            hide-details
            @input="$emit('update:pos3', $event)" />
        </div>
        <div class="d-flex align-center gap-3 mb-5">
          <div class="">
            แสดงตัวเลขบาร์โค้ด
          </div>
          <v-spacer />
          <v-switch
            :input-value="showBarcodeNumber"
            class="mt-0"
            color="primary"
            hide-details
            inset
            @change="$emit('update:show-barcode-number', $event)" />
        </div>
      </v-tab-item>
      <v-tab-item
        :value="1"
        class="pa-5">
        <div class="primary--text mb-5">
          ตั้งค่ากระดาษ
        </div>
        <div class="d-flex align-center gap-3 mb-5">
          <div class="barcode-setup__label grey--text">
            ขนาดกระดาษ
          </div>
          <snt-select
            :value="pageSize"
            :items="paperSizes"
            width="165px"
            placeholder="กำหนดเอง"
            item-text="text"
            item-value="value"
            hide-details
            @input="$emit('update:page-size', $event)" />
        </div>
        <div class="d-flex gap-3 mb-5">
          <div class="barcode-setup__label mt-2 grey--text">
            กำหนดเอง
          </div>
          <div>
            <div class="d-flex align-center gap-3 mb-5">
              <div
                :style="{ width: '55px' }"
                class="grey--text">
                กว้าง
              </div>
              <div :style="{ width: '150px' }">
                <snt-number-field
                  :value="pageSize.width"
                  :min="25"
                  :max="1000"
                  justify-controls="end"
                  hide-details
                  rounded
                  controls
                  decimal
                  @change="$emit('update:page-size', { ...pageSize, width: Number($event)})" />
              </div>
              <div class="barcode-setup__label grey--text">
                mm
              </div>
            </div>
            <div class="d-flex align-center gap-3">
              <div
                :style="{ width: '55px' }"
                class="grey--text">
                สูง
              </div>
              <div :style="{ width: '150px' }">
                <snt-number-field
                  :value="pageSize.height"
                  :min="25"
                  :max="1000"
                  justify-controls="end"
                  hide-details
                  rounded
                  controls
                  decimal
                  @change="$emit('update:page-size', { ...pageSize, height: Number($event)})" />
              </div>
              <div class="barcode-setup__label grey--text">
                mm
              </div>
            </div>
          </div>
        </div>
        <div class="d-flex align-center gap-3 mb-5">
          <div class="barcode-setup__label grey--text">
            ขนาดฟอนต์
          </div>
          <div :style="{ width: '165px' }">
            <snt-number-field
              :value="fontSize"
              :min="4"
              :max="60"
              justify-controls="end"
              hide-details
              rounded
              controls
              decimal
              @change="$emit('update:font-size', Number($event))" />
          </div>
          <div class="barcode-setup__label grey--text">
            px
          </div>
        </div>
        <div class="mt-5 mb-5">
          จำนวนฉลากต่อหน้า
        </div>
        <div class="d-flex align-center gap-3 mb-5">
          <div class="barcode-setup__label grey--text">
            จำนวนคอลัมน์
          </div>
          <snt-select
            :value="col"
            :items="[1, 2, 3, 4, 6]"
            width="165px"
            hide-details
            @input="$emit('update:col', Number($event))" />
        </div>
        <div class="d-flex align-center gap-3 mb-5">
          <div class="barcode-setup__label grey--text">
            จำนวนแถว
          </div>
          <snt-select
            :value="row"
            :items="[1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]"
            width="165px"
            hide-details
            @input="$emit('update:row', Number($event))" />
        </div>
        <div class="mt-5 mb-5">
          จำนวนสำเนา
        </div>
        <div class="d-flex align-center gap-3">
          <div class="barcode-setup__label grey--text">
            สำเนา
          </div>
          <div :style="{ width: '165px' }">
            <snt-number-field
              :value="copied"
              :min="1"
              justify-controls="end"
              hide-details
              rounded
              controls
              @input="$emit('update:copied', Number($event))" />
          </div>
        </div>
      </v-tab-item>
      <v-tab-item
        :value="2"
        class="pa-5">
        <div class="primary--text mb-5 ">
          ตั้งค่าระยะขอบ
        </div>
        <div class="mt-5 mb-5">
          ระยะขอบกระดาษ
        </div>
        <div class="d-flex align-center gap-3 mb-5">
          <div class="barcode-setup__label grey--text">
            ระยะขอบซ้าย
          </div>
          <div :style="{ width: '100px' }">
            <snt-number-field
              :value="mx"
              :min="0"
              justify-controls="end"
              hide-details
              rounded
              controls
              decimal
              @input="$emit('update:mx', Number($event))" />
          </div>
          <div class="barcode-setup__label grey--text">
            mm
          </div>
        </div>
        <div class="d-flex align-center gap-3 mb-5">
          <div class="barcode-setup__label grey--text">
            ระยะขอบบน
          </div>
          <div :style="{ width: '100px' }">
            <snt-number-field
              :value="my"
              :min="0"
              justify-controls="end"
              hide-details
              rounded
              controls
              decimal
              @input="$emit('update:my', Number($event))" />
          </div>
          <div class="barcode-setup__label grey--text">
            mm
          </div>
        </div>
        <div class="mt-10 mb-5">
          ระยะห่างฉลาก
        </div>
        <div class="d-flex align-center gap-3 mb-5">
          <div class="barcode-setup__label grey--text">
            ระยะขอบซ้าย
          </div>
          <div :style="{ width: '100px' }">
            <snt-number-field
              :value="omx"
              :min="0"
              justify-controls="end"
              hide-details
              rounded
              controls
              decimal
              @input="$emit('update:omx', Number($event))" />
          </div>
          <div class="barcode-setup__label grey--text">
            mm
          </div>
        </div>
        <div class="d-flex align-center gap-3 mb-5">
          <div class="barcode-setup__label grey--text">
            ระยะขอบบน
          </div>
          <div :style="{ width: '100px' }">
            <snt-number-field
              :value="omy"
              :min="0"
              justify-controls="end"
              hide-details
              rounded
              controls
              decimal
              @input="$emit('update:omy', Number($event))" />
          </div>
          <div class="barcode-setup__label grey--text">
            mm
          </div>
        </div>
        <div class="mt-10 mb-5">
          ระยะห่างในฉลาก
        </div>
        <div class="d-flex align-center gap-3">
          <div class="barcode-setup__label grey--text">
            ระหว่างตำแหน่ง
          </div>
          <div :style="{ width: '100px' }">
            <snt-number-field
              :value="imy"
              :min="0"
              justify-controls="end"
              hide-details
              rounded
              controls
              decimal
              @input="$emit('update:imy', Number($event))" />
          </div>
          <div class="barcode-setup__label grey--text">
            mm
          </div>
        </div>
      </v-tab-item>
    </v-tabs-items>
  </div>
</template>

<script>

export default {
  props: {
    pos1: {
      type: String,
      default: 'name'
    },
    pos2: {
      type: String,
      default: 'barcode'
    },
    pos3: {
      type: String,
      default: 'price'
    },
    showBarcodeNumber: Boolean,
    col: {
      type: [Number],
      default: 0
    },
    row: {
      type: [Number],
      default: 0
    },
    my: {
      type: [Number],
      default: 0
    },
    mx: {
      type: [Number],
      default: 0
    },
    omy: {
      type: [Number],
      default: 0
    },
    omx: {
      type: [Number],
      default: 0
    },
    imy: {
      type: [Number],
      default: 0
    },
    copied: {
      type: [Number],
      default: 1
    },
    elements: {
      type: [Array],
      default: () => (['name', 'barcode', 'price'])
    },
    pageSize: {
      type: Object,
      default: () => ({
        width: 209,
        height: 296
      })
    },
    fontSize: {
      type: Number,
      default: 10
    },
    items: {
      type: Array,
      default: () => ([])
    }
  },
  data () {
    return {
      tab: 0,
      tabs: [
        'ข้อมูล', 'กระดาษ', 'ระยะขอบ'
      ],
      positions: [
        { value: 'name', text: 'ชื่อสินค้า' },
        { value: 'barcode', text: 'บาร์โค้ด' },
        { value: 'price', text: 'ราคา' },
        { value: 'none', text: 'ไม่แสดง' }
      ],
      paperSizes: [
        {
          text: 'A3',
          value: {
            width: 297, // 297
            height: 420 // 420
          }
        },
        {
          text: 'A4',
          value: {
            width: 210, // 210 // 794
            height: 297 // 297 // 1122
          }
        },
        {
          text: 'A5',
          value: {
            width: 148, // 148
            height: 210 // 210
          }
        }
      ]
    }
  },
  computed: {
    midPositions () {
      const noneCount = [this.pos1, this.pos3].filter((e) => e === 'none').length
      return this.positions.filter((it) => it.value !== this.pos1 || (it.value === 'none' && noneCount < 2))
    },
    lastPositions () {
      const noneCount = [this.pos1, this.pos2].filter((e) => e === 'none').length
      return this.positions.filter((it) => (it.value !== this.pos1 && it.value !== this.pos2) || (it.value === 'none' && noneCount < 2))
    }
  },
  methods: {
    changePosition1 (value) {
      const midPositions = this.positions.filter((it) => it.value !== value)
      this.$emit('update:pos1', value)
      this.$emit('update:pos2', midPositions[0].value)
      this.$emit('update:pos3', midPositions[1].value)
    },
    changePosition2 (value) {
      const lastPositions = this.positions.filter((it) => it.value !== this.pos1 && it.value !== value)
      this.$emit('update:pos2', value)
      this.$emit('update:pos3', lastPositions[0].value)
    }
  }
}
</script>

<style lang="scss" scoped>
.v-tabs {
  ::v-deep {
    .v-tab {
      margin: 0 3px;
      border-top-left-radius: 4px;
      border-top-right-radius: 4px;
      height: 40px;
      width: 100px;
    }
    .v-tab:not(.v-tab--active) {
      background-color: #ececec;
    }
    .v-tab.v-tab--active {
      border: 1px solid #E6E6E6;
      border-bottom: 0;
    }
    .v-item-group {
      align-items: flex-end;
    }
  }
}

.barcode-setup {
  overflow: auto;
  height: calc(100% - 50px);
  width: 100%;
  border: 1px solid #E6E6E6;
  flex-grow: 5;
  &__label {
    width: 110px;
  }
}
</style>
